import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-cover-food",
  "use": "icon-si-glyph-cover-food-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-cover-food\" id=\"icon-si-glyph-cover-food\"><title>1086</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 3.000000)\" fill=\"#434343\"><g transform=\"translate(0.000000, 1.000000)\"><path d=\"M15.471,8.076 L0.49,8.076 C0.219,8.076 0.001,8.283 0.001,8.537 C0.001,8.793 0.22,9 0.49,9 L15.471,9 C15.742,9 15.961,8.793 15.961,8.537 C15.961,8.283 15.741,8.076 15.471,8.076 L15.471,8.076 Z\" class=\"si-glyph-fill\" /><path d=\"M7.987,0.201 C4.148,0.201 1.037,3.209 1.037,6.919 L14.937,6.919 C14.938,3.209 11.825,0.201 7.987,0.201 L7.987,0.201 Z\" class=\"si-glyph-fill\" /></g><rect x=\"7\" y=\"0\" width=\"1.969\" height=\"1.969\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-cover-food.svg
// module id = g+dy
// module chunks = 62